/**
 * Stałe layoutów akapitów — 1:1 mirror `web/define.php` (linie 918-939).
 *
 * **Single source of truth** dla typu akapitu w React-CMS — używane przez
 * dispatcher `<Paragraph>` oraz typy discriminated union `ParagraphData`
 * w `@/lib/api/cms-catalog`.
 *
 * Numery NIE są arbitralne — backend (`IPARAGRAPH_CONTROLLER`) zwraca te
 * wartości w polu `layout` per akapit. Każda zmiana po stronie PHP musi
 * mieć odpowiednik tutaj (oba pliki muszą zostać zsynchronizowane).
 *
 * **System-wide reusable:** ten plik jest celowo poza `components/cms/Paragraphs/`
 * żeby każdy moduł CMS / okna / panel admina mógł go zaimportować bez
 * zależności od konkretnego renderera. Lista typów akapitów = część kontraktu
 * API Imperial, nie implementacja UI.
 */

/** Akapit tylko tekst. */
export const PARAGRAPH_TEXT_LAYOUT = 1;

/** Tekst + obrazy po lewej. */
export const PARAGRAPH_TEXT_IMAGES_LEFT_LAYOUT = 2;
/** Tekst + obrazy po prawej. */
export const PARAGRAPH_TEXT_IMAGES_RIGHT_LAYOUT = 3;
/** Tekst + obrazy nad tekstem. */
export const PARAGRAPH_TEXT_IMAGES_TOP_LAYOUT = 4;
/** Tekst + obrazy pod tekstem. */
export const PARAGRAPH_TEXT_IMAGES_BOT_LAYOUT = 5;

/** 2 kolumny tekstu (text|text_1). */
export const PARAGRAPH_TWO_COLS_TEXT_LAYOUT = 14;
/** 2 kolumny: tekst | YouTube. */
export const PARAGRAPH_TWO_COLS_TEXT_VIDEO_LAYOUT = 6;
/** 2 kolumny: tabela HTML | tekst. */
export const PARAGRAPH_TWO_COLS_TABLE_TEXT_LAYOUT = 12;
/** 2 kolumny: tekst + galeria zdjęć obok. */
export const PARAGRAPH_TWO_COLS_TEXT_GALLERY_LAYOUT = 13;

/** Slider zdjęć (Swiper). */
export const PARAGRAPH_PREZENTATION_LAYOUT = 7;
/** Duże zdjęcie pojedyncze. */
export const PARAGRAPH_BIG_PHOTO_LAYOUT = 15;

/** 3 kolumny tekstu (text|text_1|text_2). */
export const PARAGRAPH_THREE_COLS_TEXT_LAYOUT = 16;
/** 3 kolumny: text | text_1 | photo. */
export const PARAGRAPH_THREE_COLS_TEXT_TEXT_PHOTO_LAYOUT = 8;
/** 3 kolumny: text | photo | text_1. */
export const PARAGRAPH_THREE_COLS_TEXT_PHOTO_TEXT_LAYOUT = 9;
/** 3 kolumny: photo | text | text_1. */
export const PARAGRAPH_THREE_COLS_PHOTO_TEXT_TEXT_LAYOUT = 10;
/** 3 kolumny z dużym YouTube. */
export const PARAGRAPH_THREE_COLS_BIG_VIDEO_LAYOUT = 11;

/** 2 boksy z obrazem + tytułem + CTA. */
export const PARAGRAPH_TWO_BOXES_LAYOUT = 17;
/** 3 boksy z obrazem + tytułem + CTA. */
export const PARAGRAPH_THREE_BOXES_LAYOUT = 18;

/** Formularz kontaktowy (email/phone/text + RODO). */
export const PARAGRAPH_CONTACT_FORM_LAYOUT = 22;
/** Mapa Leaflet z punktami GPX. */
export const PARAGRAPH_MAPS_LAYOUT = 23;
/** 2 kolumny: tekst | prezentacja zdjęć. */
export const PARAGRAPH_TWO_COLS_TEXT_PREZENTATION_LAYOUT = 24;
/** Karuzela / lista wpisów c_blog. */
export const PARAGRAPH_BLOG_POSTS_LAYOUT = 25;

/**
 * Union literal typów wszystkich layoutów — używane przez discriminated
 * union `ParagraphData` jako wartość pola `layout`.
 */
export type ParagraphLayoutId =
  | typeof PARAGRAPH_TEXT_LAYOUT
  | typeof PARAGRAPH_TEXT_IMAGES_LEFT_LAYOUT
  | typeof PARAGRAPH_TEXT_IMAGES_RIGHT_LAYOUT
  | typeof PARAGRAPH_TEXT_IMAGES_TOP_LAYOUT
  | typeof PARAGRAPH_TEXT_IMAGES_BOT_LAYOUT
  | typeof PARAGRAPH_TWO_COLS_TEXT_LAYOUT
  | typeof PARAGRAPH_TWO_COLS_TEXT_VIDEO_LAYOUT
  | typeof PARAGRAPH_TWO_COLS_TABLE_TEXT_LAYOUT
  | typeof PARAGRAPH_TWO_COLS_TEXT_GALLERY_LAYOUT
  | typeof PARAGRAPH_PREZENTATION_LAYOUT
  | typeof PARAGRAPH_BIG_PHOTO_LAYOUT
  | typeof PARAGRAPH_THREE_COLS_TEXT_LAYOUT
  | typeof PARAGRAPH_THREE_COLS_TEXT_TEXT_PHOTO_LAYOUT
  | typeof PARAGRAPH_THREE_COLS_TEXT_PHOTO_TEXT_LAYOUT
  | typeof PARAGRAPH_THREE_COLS_PHOTO_TEXT_TEXT_LAYOUT
  | typeof PARAGRAPH_THREE_COLS_BIG_VIDEO_LAYOUT
  | typeof PARAGRAPH_TWO_BOXES_LAYOUT
  | typeof PARAGRAPH_THREE_BOXES_LAYOUT
  | typeof PARAGRAPH_CONTACT_FORM_LAYOUT
  | typeof PARAGRAPH_MAPS_LAYOUT
  | typeof PARAGRAPH_TWO_COLS_TEXT_PREZENTATION_LAYOUT
  | typeof PARAGRAPH_BLOG_POSTS_LAYOUT;
